import { useEffect, useState } from "react";

import { usePublishNode } from "../../pages/devices/hooks/usePublishNode";
import { extractDeviceNameFromId } from "../utils/getEntityName";
import { selectedStreamObjectVariable } from "../variables/selectedStreamObject";
import {
  useVideoPlayerVariable,
  videoPlayerVariable,
} from "../variables/videoPlayer";
import { useStream } from "./useStream";

interface IDeviceStream {
  deviceId: string;
  nodeId: string;
  hasPanTilt?: boolean;
}

export const useStreamProcesses = () => {
  const [isVideoLoaded, setIsVideoLoaded] = useState(false);
  const [streamLoading, setStreamLoading] = useState(false);
  const [hasPanTilt, setHasPanTilt] = useState(false);

  const { getStreamName } = useStream();
  const { publishNode } = usePublishNode();

  const isPlayerLoaded = useVideoPlayerVariable();

  const startStreaming = ({
    deviceId,
    nodeId,
    hasPanTilt = false,
  }: IDeviceStream): void => {
    setStreamLoading(true);

    const { extractedDeviceName } = extractDeviceNameFromId(deviceId);

    const streamName = getStreamName(nodeId, deviceId);

    // set showPanTiltButton according to device data
    setHasPanTilt(hasPanTilt);

    if (!isPlayerLoaded) {
      publishNode({
        message: JSON.stringify({
          TARGET: "KINESIS_STREAM",
          ACTION: "KINESIS_STREAM_START",
          streamName,
          deviceName: extractedDeviceName,
        }),
        nodeId,
      }).then((): void => {
        selectedStreamObjectVariable({
          streamName,
          extractedDeviceName,
          nodeId,
        });

        setStreamLoading(false);
      });
    }
  };

  useEffect((): void => {
    setIsVideoLoaded(isPlayerLoaded);
  }, [isPlayerLoaded]);

  const stopStreaming = ({ deviceId, nodeId }: IDeviceStream): void => {
    const { extractedDeviceName } = extractDeviceNameFromId(deviceId);

    const streamName = getStreamName(nodeId, deviceId);

    if (streamName) {
      publishNode({
        message: JSON.stringify({
          TARGET: "KINESIS_STREAM",
          ACTION: "KINESIS_STREAM_END",
          streamName,
          deviceName: extractedDeviceName,
        }),
        nodeId,
      });

      selectedStreamObjectVariable(null);

      videoPlayerVariable(false);
    }
  };

  return {
    isVideoLoaded,
    hasPanTilt,
    streamLoading,
    startStreaming,
    stopStreaming,
  };
};
